import { CSS_VARIABLES } from "enums/cssVariables";

export const styles = `
    ${CSS_VARIABLES.PRIMARY_BUTTON_BACKGROUND_COLOR}: #607d91;
    ${CSS_VARIABLES.PRIMARY_TEXT_COLOR}: #607d91;
`;
